import { render } from "./RunRunJumpPunch.vue?vue&type=template&id=2c2dbe15"
import script from "./RunRunJumpPunch.vue?vue&type=script&lang=js"
export * from "./RunRunJumpPunch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__